import { FunctionComponent } from 'react';
import {
  Action,
  BannerStatus,
  Banner as ShopifyBanner,
} from '@shopify/polaris';

interface BannerProps {
  title: string;
  status: BannerStatus;
  action?: Action;
  onDismiss?(): void;
  children?: React.ReactNode;
}

const Banner: FunctionComponent<BannerProps> = (props) => {
  const { children } = props;
  return <ShopifyBanner {...props}>{children}</ShopifyBanner>;
};

export default Banner;
